import type { ControlPlanRow } from "@playbookai/widget-schemas";

export function isCompleteControl(row: ControlPlanRow): boolean {
  return [row.item, row.cadence, row.responsible, row.trigger].every(
    (value) => value.trim().length > 0,
  );
}
